module.exports = __webpack_public_path__ + "img/图片1.1b6d73da.png";